import { Action } from "./action";
import { Marker } from "./marker";

export enum StencilType {
  ACTION = "ACTION",
  MARKER = "MARKER",
}

export interface Point {
  x: number;
  y: number;
}

export type FrameStencil = Marker | Action;
